"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padNumberWithPrefixZero = exports.clearHtmlTags = void 0;
var padNumberWithPrefixZero = function padNumberWithPrefixZero(num) {
  return num < 10 ? "0".concat(num) : "".concat(num);
};
exports.padNumberWithPrefixZero = padNumberWithPrefixZero;
var clearHtmlTags = function clearHtmlTags(text, maxLength) {
  var div = document.createElement('div');
  div.innerHTML = text || '';
  var cleanText = div.innerText;
  if (maxLength) {
    cleanText = cleanText.substring(0, maxLength);
  }
  return cleanText;
};
exports.clearHtmlTags = clearHtmlTags;